module.exports = __webpack_public_path__ + "static/media/bread.78fbce77.svg";